const isAppleProduct = (): boolean => {
  const isApple = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
  return isApple;
};

export default isAppleProduct;
